import { Card, Group, SimpleGrid, Skeleton, Stack } from "@mantine/core";

/** A page loading: a title, a row of cards, a block. */
export function PageSkeleton() {
  return (
    <Stack gap="lg" aria-busy="true" aria-label="Loading">
      <Skeleton h={26} w={200} />
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }}>
        {[0, 1, 2, 3].map((i) => (
          <Card key={i} padding="md">
            <Skeleton h={12} w={90} mb={12} />
            <Skeleton h={26} w={140} />
          </Card>
        ))}
      </SimpleGrid>
      <Card padding="lg">
        <Skeleton h={280} />
      </Card>
    </Stack>
  );
}

/** A table loading: header plus rows of bars. */
export function TableSkeleton({ rows = 6, cols = 5 }: { rows?: number; cols?: number }) {
  return (
    <Card padding="lg" aria-busy="true" aria-label="Loading">
      <Stack gap={12}>
        {Array.from({ length: rows + 1 }, (_, r) => (
          <Group key={r} gap="md" wrap="nowrap">
            {Array.from({ length: cols }, (_, c) => (
              <Skeleton key={c} h={r === 0 ? 10 : 14} style={{ flex: c === 0 ? 2 : 1 }} />
            ))}
          </Group>
        ))}
      </Stack>
    </Card>
  );
}
